export const learn_url: string = "training";
export const updates_url: string = "updates";
export const roadmap_url: string = "roadmap";

export const customer_url: string = "customer";
export const quote_url: string = "quote";
export const business_details_url: string = "business";
export const basic_sketch_url: string = "basic_sketch";
export const market_url: string = "market";
